  import React, { useEffect } from 'react';
  import { Link, NavLink, useLocation } from 'react-router-dom';
  import './Navbar.css';

  const Navbar = () => {
    const location = useLocation();


    useEffect(() => {
      if (location.hash) {
        const id = location.hash.replace('#', '');
        const el = document.getElementById(id);
        if (el) {
          setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
        }
      }
    }, [location]);

    const navConfig = [
      { title: 'Home', path: '/' },
      {
        title: 'Research',
        path: '/research',
        dropdown: [
          { label: 'Economic Research', link: '/research', hash: 'Economic-Research' },
          { label: 'Digital Brain Research', link: '/research', hash: 'Digital_Brain_Research' },
          { label: 'Generative AI Research', link: '/research', hash: 'generative' }
        ]
      },
      {
        title: 'Products',
        path: '/products',
        dropdown: [
          { label: 'Regulators', link: '/products', hash: 'regulators' },
          { label: 'AI Doctor', link: '/products', hash: 'ai_doctor' }
        ]
      },
      {
        title: 'Patents',
        path: '/patents',
        dropdown: [
          { label: 'Doctor Patent', link: '/patents', hash: 'doctor' },
          { label: 'AI Teacher Patent', link: '/patents', hash: 'teacher' },
          { label: 'AI Analyst Patent', link: '/patents', hash: 'analytic' },
          { label: 'Lawyer Patent', link: '/patents', hash: 'lawyer' }
        ]
      },
      { title: 'About Us', path: '/about' }
    ];


    const closeMenu = () => {
      const checkbox = document.getElementById('nav-checkbox');
      if (checkbox) checkbox.checked = false;
    };

    return (
      <nav className="navbar_1">
        <div className="logo_1">
          <Link
            to="/"
            style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}
            onClick={closeMenu}
          >
            <img
              src="/logo.png"
              alt="Logo"
              className="logo-img_1"
            />
            <div className="logo-text_1">
              <div className="brand-name_1">CNYDA DYNAMICS</div>
              <div className="brand-sub_1">Research & Development</div>
            </div>
          </Link>
        </div>

        <input type="checkbox" id="nav-checkbox" className="nav-checkbox_1" />
        <label htmlFor="nav-checkbox" className="nav-overlay_1"></label>

        <label htmlFor="nav-checkbox" className="nav-toggle-btn_1">
          <span className="bars"></span>
          <span bar_name="true">menu</span>
          <span className="bars"></span>
        </label>

        <ul className="nav-links_1">
          {navConfig.map((item, index) => (
            <li key={index} className="nav-item_1">
              <NavLink
                to={item.path}
                className={({ isActive }) => (isActive ? 'active-link' : '')}
                onClick={closeMenu}
              >
                {item.title}
              </NavLink>

              {item.dropdown && (
                <div className="dropdown_1">
                  {item.dropdown.map((dropItem, dropIndex) => (
                    <Link
                      key={dropIndex}
                      to={`${dropItem.link}#${dropItem.hash}`}
                      onClick={closeMenu}
                    >
                      {dropItem.label}
                    </Link>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>
      </nav>
    );
  };

  export default Navbar;